import React, { ReactNode } from 'react';
import Avatar from '../Avatar';
import Text from '../Text';
import withSkeleton from '../../hoc/withSkeleton';
import TeacherProfileCardSkeleton from './TeacherProfileCardSkeleton';
import TeacherProfile from '../../images/teacherProfile.png';
import IconSubject from '../Icons/IconSubject';
import IconLetter from '../Icons/IconLetter';
import ReactPlayer from 'react-player';
import Wrapper from '../Wrapper';
import './TeacherProfileCard.less';
import ImageCard from '../ImageCard';

export type TeacherType = {
  image?: string;
  name: string;
  avatarName?: string;
  description?: string;
  actions?: ReactNode;
  subject?: string;
  email?: string;
  coverHeight?: string;
  video?: string;
  moreInfo?: ReactNode;
};

type TeacherTypeProps = {
  teacher: TeacherType;
  coverHeight: string;
  teacherProfileCover?: string;
};

const TTeacherProfileCard: React.FC<TeacherTypeProps> = ({
  teacher,
  coverHeight = '300px',
  teacherProfileCover = '',
}) => {
  const {
    name = '',
    avatarName = '',
    image = '',
    email = '',
    subject = '',
    video = '',
    moreInfo,
    actions,
  } = teacher;
  return (
    <div className="t-teacher-profile-container">
      <ImageCard
        coverHeight={coverHeight}
        cover={
          !video ? (
            <div className="t-teacher-profile-cover-photo">
              <img
                src={teacherProfileCover ? teacherProfileCover : TeacherProfile}
                style={{
                  height: coverHeight,
                  objectFit: 'cover',
                  width: '100%',
                }}
              />
            </div>
          ) : (
            <div className="t-teacher-profile-cover-photo">
              <ReactPlayer controls width="100%" height="100%" url={video} />
            </div>
          )
        }
      >
        <Wrapper display="flex" alignItems="center" mb={1}>
          <Avatar size="lm" boldText name={avatarName} src={image} />
          <Wrapper ml={2}>
            <Text rows={2} bold>
              {name}
            </Text>
            {!!subject && (
              <Wrapper display="flex" alignItems="center">
                <Wrapper mr={3}>
                  <IconSubject fill="#909091" />
                </Wrapper>
                <Text textColor="dark-50" level={3}>
                  {subject}
                </Text>
              </Wrapper>
            )}
            {moreInfo && (
              <Wrapper display="flex" textAlign="center" py={3}>
                {moreInfo}
              </Wrapper>
            )}
          </Wrapper>
        </Wrapper>
        {!!email && (
          <Wrapper display="flex" alignItems="center">
            <Wrapper mr={3}>
              <IconLetter fill="#909091" />
            </Wrapper>
            <Text textColor="dark-50" level={3}>
              {email}
            </Text>
          </Wrapper>
        )}
        {!!actions && (
          <Wrapper display="flex" justifyContent="flex-end">
            {actions}
          </Wrapper>
        )}
      </ImageCard>
    </div>
  );
};

export default withSkeleton(TTeacherProfileCard, TeacherProfileCardSkeleton);
